import CONFIG from "@/config";

/**
 * Formats the phone according to the parameters defined in the CONFIG file
 * @param phoneNumber phone number to be formatted
 */
export const formatPhone = (phoneNumber: string) => {
  let phone = phoneNumber;
  if (phone && phone.length > 0) {
    phone = phone
      .replace(/[^0-9]/g, "")
      .replace(
        CONFIG.phoneNumberDisplay.searchValue,
        CONFIG.phoneNumberDisplay.newValue
      );
  }
  return phone;
};
